export default __webpack_public_path__ + "static/media/Rare.cad3254f.png";